// TODO - Need to handle import

import { CreateAggregatorType } from 'utils/schema/aggregatorSchema'
import Api from './axiosInstance'
import { API_AGGREGATOR_MGMT } from 'utils/constants'

type FetchAggregatorsParams = {
  limit: number
  page: number
  search?: string
  isActive?: boolean
}

const fetchAggregators = ({
  limit,
  page,
  search,
  isActive,
}: FetchAggregatorsParams) => {
  const options: any = {}

  if (search) {
    options.search = search
  }

  if (isActive !== undefined) {
    options.isActive = isActive
  }

  const params = new URLSearchParams({
    limit,
    page,
    ...options,
  })

  return Api.get({
    url: `${API_AGGREGATOR_MGMT.AGGREGATOR}?${params}`,
  })
}

/**
 * Get Aggregator Details
 */
const getAggregator = (aggregatorId: string) => {
  return Api.get({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${aggregatorId}` })
}

const createAggregator = (data: CreateAggregatorType) => {
  return Api.post({ url: API_AGGREGATOR_MGMT.AGGREGATOR, data: data })
}

const deleteAggregator = (id: string) => {
  return Api.delete({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}` })
}

const updateAggregator = (id: string, data: CreateAggregatorType) => {
  return Api.patch({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}`, data })
}

const generateOrderTokenAggregator = (id: string) => {
  return Api.post({ url: `${API_AGGREGATOR_MGMT.AGGREGATOR}/${id}` })
}

export {
  createAggregator,
  deleteAggregator,
  fetchAggregators,
  updateAggregator,
  getAggregator,
  generateOrderTokenAggregator,
}
